/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateAccountStatusRequest} from '../models/UpdateAccountStatusRequest';
import type {UpdateAccountStatusResponse} from '../models/UpdateAccountStatusResponse';

export interface GetAccountStatusBulkUpdateResult$Request {
    id: string;
}

export interface GetAccountStatusBulkUpdateResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountStatusBulkUpdateResultRequest = createAction<PayloadData<void, GetAccountStatusBulkUpdateResult$Request>>('ACCOUNT_STATUS_BULK_UPDATE__GET_ACCOUNT_STATUS_BULK_UPDATE_RESULT__REQUEST');
export const getAccountStatusBulkUpdateResultSuccess = createAction<PayloadData<UpdateAccountStatusResponse, GetAccountStatusBulkUpdateResult$Request>>('ACCOUNT_STATUS_BULK_UPDATE__GET_ACCOUNT_STATUS_BULK_UPDATE_RESULT__SUCCESS');
export const getAccountStatusBulkUpdateResultFailure = createAction<PayloadData<Error, GetAccountStatusBulkUpdateResult$Request, true>>('ACCOUNT_STATUS_BULK_UPDATE__GET_ACCOUNT_STATUS_BULK_UPDATE_RESULT__FAILURE');

export const getAccountStatusBulkUpdateResultActions = [
    getAccountStatusBulkUpdateResultRequest,
    getAccountStatusBulkUpdateResultSuccess,
    getAccountStatusBulkUpdateResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountStatusBulkUpdateResult = (meta: GetAccountStatusBulkUpdateResult$Request, config?: GetAccountStatusBulkUpdateResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAccountStatusBulkUpdateResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/statuses`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetBulkAccountsStatusesProgress$Request {
    id: string;
}

export interface GetBulkAccountsStatusesProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBulkAccountsStatusesProgressRequest = createAction<PayloadData<void, GetBulkAccountsStatusesProgress$Request>>('ACCOUNT_STATUS_BULK_UPDATE__GET_BULK_ACCOUNTS_STATUSES_PROGRESS__REQUEST');
export const getBulkAccountsStatusesProgressSuccess = createAction<PayloadData<BulkProgress, GetBulkAccountsStatusesProgress$Request>>('ACCOUNT_STATUS_BULK_UPDATE__GET_BULK_ACCOUNTS_STATUSES_PROGRESS__SUCCESS');
export const getBulkAccountsStatusesProgressFailure = createAction<PayloadData<Error, GetBulkAccountsStatusesProgress$Request, true>>('ACCOUNT_STATUS_BULK_UPDATE__GET_BULK_ACCOUNTS_STATUSES_PROGRESS__FAILURE');

export const getBulkAccountsStatusesProgressActions = [
    getBulkAccountsStatusesProgressRequest,
    getBulkAccountsStatusesProgressSuccess,
    getBulkAccountsStatusesProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBulkAccountsStatusesProgress = (meta: GetBulkAccountsStatusesProgress$Request, config?: GetBulkAccountsStatusesProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getBulkAccountsStatusesProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/statuses/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopAccountStatusBulkUpdate$Request {
    id: string;
}

export interface StopAccountStatusBulkUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopAccountStatusBulkUpdateRequest = createAction<PayloadData<void, StopAccountStatusBulkUpdate$Request>>('ACCOUNT_STATUS_BULK_UPDATE__STOP_ACCOUNT_STATUS_BULK_UPDATE__REQUEST');
export const stopAccountStatusBulkUpdateSuccess = createAction<PayloadData<void, StopAccountStatusBulkUpdate$Request>>('ACCOUNT_STATUS_BULK_UPDATE__STOP_ACCOUNT_STATUS_BULK_UPDATE__SUCCESS');
export const stopAccountStatusBulkUpdateFailure = createAction<PayloadData<Error, StopAccountStatusBulkUpdate$Request, true>>('ACCOUNT_STATUS_BULK_UPDATE__STOP_ACCOUNT_STATUS_BULK_UPDATE__FAILURE');

export const stopAccountStatusBulkUpdateActions = [
    stopAccountStatusBulkUpdateRequest,
    stopAccountStatusBulkUpdateSuccess,
    stopAccountStatusBulkUpdateFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopAccountStatusBulkUpdate = (meta: StopAccountStatusBulkUpdate$Request, config?: StopAccountStatusBulkUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopAccountStatusBulkUpdateActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/accounts/statuses`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAccountStatus$Request {
    reason?: string;
    updateAccountStatusRequest?: UpdateAccountStatusRequest;
}

export interface UpdateAccountStatus$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountStatusRequest = createAction<PayloadData<void, UpdateAccountStatus$Request>>('ACCOUNT_STATUS_BULK_UPDATE__UPDATE_ACCOUNT_STATUS__REQUEST');
export const updateAccountStatusSuccess = createAction<PayloadData<string, UpdateAccountStatus$Request>>('ACCOUNT_STATUS_BULK_UPDATE__UPDATE_ACCOUNT_STATUS__SUCCESS');
export const updateAccountStatusFailure = createAction<PayloadData<Error, UpdateAccountStatus$Request, true>>('ACCOUNT_STATUS_BULK_UPDATE__UPDATE_ACCOUNT_STATUS__FAILURE');

export const updateAccountStatusActions = [
    updateAccountStatusRequest,
    updateAccountStatusSuccess,
    updateAccountStatusFailure
] as const;

/**
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {UpdateAccountStatusRequest} [meta.updateAccountStatusRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountStatus = (meta: UpdateAccountStatus$Request, config?: UpdateAccountStatus$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: updateAccountStatusActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/accounts/statuses`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateAccountStatusRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

